<template>
  <div id="app">
    <header class="header">
      <div class="title">{{ wxInfo.company }}</div>
      <div class="user">
        <div class="user_left">
          <img class="user_head" :src="wxInfo.headImgUrl" alt="" />
          <div class="user_info">
            <div class="user_name">{{ wxInfo.nickname }}</div>
            <div v-if="!bindStatus" class="user_phone" @click="toBind">
              绑定手机号＞
            </div>
            <div v-else class="user_phone">{{ wxInfo.phone }}</div>
          </div>
        </div>
        <!-- <div class="user_right">
          <div class="user_right_text">青铜会员II</div>
        </div> -->
      </div>
    </header>
    <main :style="wxInfo.subscribeStatus ? 'height: calc(100% - 5.75rem + 1.3rem);' : 'height: calc(100% - 5.75rem);'">
      <header class="main_header">
        <div class="main_header_item">
          <div class="num">{{ orderInfo.billCount }}</div>
          <div class="balance">订单数</div>
        </div>
        <div class="main_header_item">
          <div class="num">￥{{ orderInfo.billSum }}</div>
          <div class="balance">订单额</div>
        </div>
        <!-- <div class="main_header_item">
                    <div class="num">￥15</div>
                    <div class="balance">会员余额</div>
                </div> -->
      </header>

      <div class="bill_tab">
        <van-tabs v-model="selectedBillIndex" type="card" color="#F5F5F5" background="#F5F5F5"
        title-active-color="#495CE1" title-inactive-color="#666666" @click="refreshUserBills">
        <van-tab :title="item.name" v-for="(item, index) in bills" :key="index"
        title-class="tab_title">
        </van-tab>
      </van-tabs>
      </div>

      <div
        v-if="billList.length != 0"
        class="main"
      >
      <div v-for="(item, index) in billList" :key="index">
        <sale-bill-list-item v-if="bills[selectedBillIndex].key === 'SALE_BILL'"
        :number="item.number" :status="item.status"
        :sum="item.sum" :paid="item.paid" :goodsDetails="item.goodsDetails"
        :date="item.date" @click="toSaleBillDetial(item)">
        </sale-bill-list-item>

        <receipt-bill-list-item v-else-if="bills[selectedBillIndex].key === 'RECEIPT_BILL'"
        :number="item.number" :sum="item.sum" :balanceMethod="item.balanceMethod"
        :billBalanceDetails="item.billBalanceDetails"
        :goodsBalanceDetails="item.goodsBalanceDetails"
        :dateTime="item.dateTime" @click="toReceiptBillDetail(item)">
        </receipt-bill-list-item>

        <goods-change-bill-list-item  v-else-if="bills[selectedBillIndex].key === 'GOODS_CHANGE_BILL'"
        :number="item.number" :changeDifferenceSum="item.changeDifferenceSum"
        :goodsDetails="item.goodsDetails"
        :changeGoodsDetails="item.changeGoodsDetails"
        :dateTime="item.dateTime" @click="toGoodsChangeBill(item)">
        </goods-change-bill-list-item>

        <goods-return-bill-list-item  v-else-if="bills[selectedBillIndex].key === 'GOODS_RETURN_BILL'"
        :number="item.number" :sum="item.sum" :goodsDetails="item.goodsDetails"
        :dateTime="item.dateTime" @click="toGoodsReturnBill(item)">
        </goods-return-bill-list-item>

        <change-receivable-bill-list-item v-else-if="bills[selectedBillIndex].key === 'CHANGE_RECEIVABLE_BILL'"
        :number="item.number" :sum="item.sum"
        :changeReceivableType="item.changeReceivableType"
        :dateTime="item.dateTime">
        </change-receivable-bill-list-item>

        <combine-bill-list-item v-else-if="bills[selectedBillIndex].key === 'COMBINE_BILL'"
        :number="item.number" :sum="item.sum"
        :otherItemSum="item.otherItemSum" :otherItemDetails="item.otherItemDetails"
        :paid="item.paid" :goodsDetails="item.goodsDetails"
        :date="item.date" @click="toCombineBill(item)">
        </combine-bill-list-item>

      </div>
      <div class="more" v-show="isshow" @click="loadMore">加载更多...</div>
      </div>
      <div v-else class="empty">
        <img src="../static/image/empty.png" alt="" />
        暂无订单数据
      </div>
    </main>
    <footer class="footer" v-if="!wxInfo.subscribeStatus">
      <div class="footer_left">
        <img class="footer_user_head" :src="userInfo.gzhHeadImg" alt="" />
        <div class="footer_des">关注“{{ userInfo.gzhName }}”公众号</div>
      </div>
      <div class="footer_rifht" @click="attention">关注</div>
    </footer>
    <div class="qrCode_box" v-show="qrCodeStatus">
      <div class="qrCode">
        <div class="qrCode_title">关注公众号</div>
        <img :src="userInfo.gzhQrCodeUrl" />
        <div class="qr_text">长按识别二维码</div>
        <div class="btn" @click="clear">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
// const urlencode = require('urlencode');

import {
  headers,
  getUserInfo,
  getCodeStatus,
  getOrderNum,
  pageSaleBill,
  pageReceiptBill,
  pageGoodsChangeBill,
  pageGoodsReturnBill,
  pageChangeReceivableBill,
  pageCombineBill
} from "@/api/user.js";

import saleBillListItem from "../components/bill/saleBillListItem.vue";
import receiptBillListItem from "../components/bill/receiptBillListItem.vue";
import goodsChangeBillListItem from "../components/bill/goodsChangeBillListItem.vue";
import goodsReturnBillListItem from "../components/bill/goodsReturnBillListItem.vue";
import changeReceivableBillListItem from "../components/bill/changeReceivableBillListItem.vue";
import combineBillListItem from "../components/bill/combineBillListItem.vue";

import wxAuth from "../module/wx-auth";



export default {
  data() {
    return {
      userInfo: {},
      wxInfo: {},
      orderInfo: {},
      isshow: true,
      bindStatus: false,
      page: 1,
      size: 20,
      maxPage: 1,
      billList: [],
      param: {},
      qrCodeStatus: false,
      selectedBillIndex: 0,
      bills: [
        {
          name: "销售单",
          key: "SALE_BILL",
          codes: [115, 117],
          pageList: pageSaleBill
        },
        {
          name: "收款单",
          key: "RECEIPT_BILL",
          codes: [171],
          pageList: pageReceiptBill
        },
        {
          name: "换货单",
          key: "GOODS_CHANGE_BILL",
          codes: [120],
          pageList: pageGoodsChangeBill
        },
        {
          name: "退货单",
          key: "GOODS_RETURN_BILL",
          codes: [116],
          pageList: pageGoodsReturnBill 
        },
        {
          name: "调账单",
          key: "CHANGE_RECEIVABLE_BILL",
          codes: [187, 188],
          pageList: pageChangeReceivableBill
        },
        {
          name: "组合单",
          key: "COMBINE_BILL",
          codes: [121],
          pageList: pageCombineBill
        }
      ]
    };
  },

  components: {
    saleBillListItem,
    receiptBillListItem,
    goodsChangeBillListItem,
    goodsReturnBillListItem,
    changeReceivableBillListItem,
    combineBillListItem
  },

  methods: {
    // 跳转组合单详情页
    toCombineBill(bill) {
      let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
      this.$router.push({
        name: "CombineBill",
        query: {
          customerId: noDecodeCustomerId,
          billId: bill.billId,
          billType: bill.billType,
        }
      });
    },

    // 跳转退货单详情页
    toGoodsReturnBill(bill) {
      let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
      this.$router.push({
        name: "GoodsReturnBill",
        query: {
          customerId: noDecodeCustomerId,
          billId: bill.billId,
          billType: bill.billType,
        }
      });
    },

    // 跳转换货单详情页
    toGoodsChangeBill(bill) {
      let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
      this.$router.push({
        name: "GoodsChangeBill",
        query: {
          customerId: noDecodeCustomerId,
          billId: bill.billId,
          billType: bill.billType,
        }
      });
    },

    // 跳转收款单详情页
    toReceiptBillDetail(bill) {
      let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
      this.$router.push({
        name: "ReceiptBillDetail",
        query: {
          customerId: noDecodeCustomerId,
          billId: bill.billId,
          billType: bill.billType,
        }
      });
    },

    // 跳转销售单详情页
    toSaleBillDetial(bill) {
      let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
      this.$router.push({
        name: "SaleBillDetial",
        query: {
          customerId: noDecodeCustomerId,
          billId: bill.billId,
          billType: bill.billType,
        }
      });
    },

    // 刷新用户单据
    refreshUserBills() {
      this.page = 1;
      this.size = 20;
      this.billList = [];
      this.maxPage = 1;
      this.isshow = true;
      this.getUserBills();
    },

    // 立即绑定
    toBind() {
      let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
      window.location.href = `./xb-api/wx-user/wx_auth?customerId=${noDecodeCustomerId}`;
    },

    // 关注
    attention() {
      this.qrCodeStatus = true;
    },

    // 关闭二维码图标
    async clear() {
      this.qrCodeStatus = false;
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      await this.getUserInfo();
      this.getCodeStatus();
      this.getOrderNum();
      this.getUserBills();
    },
    // 加载更多
    loadMore() {
      this.page += 1;
      this.getUserBills();
    },

    // 获取用户单据
    getUserBills() {
      var selectedBillIndex = this.selectedBillIndex;
      var bill = this.bills[selectedBillIndex];
      let param = {
        page: this.page,
        size: this.size,
        dealingsCompanyIdList: this.wxInfo.dealingsCompanyIdList
      };
      bill.pageList(param).then((res) => {
        if (res.code == "10000") {
          this.maxPage = res.data.pages;
          this.billList.push(...res.data.records);
          if (this.page < this.maxPage) {
            this.isshow = true;
          } else {
            this.isshow = false;
          }
        }
      });
    },

    // 获取订单数信息
    getOrderNum() {
      let param = {
        dealingsCompanyIdList: this.wxInfo.dealingsCompanyIdList
      };
      getOrderNum(param).then((res) => {
        if (res.code == "10000") {
          this.orderInfo = res.data;
        }
      });
    },

    // 获取用户手机号绑定状态
    getCodeStatus() {
      let customerId = wxAuth.getDecodeCustomerId();
      let param = {
        customerId: customerId,
        openId: this.userInfo.openId,
      };
      getCodeStatus(param).then((res) => {
        if (res.code == "10000") {
          this.bindStatus = res.data;
        }
      });
    },

    // 获取微信用户信息
    async getUserInfo() {
      let userInfo = this.userInfo;
      let customerId = wxAuth.getDecodeCustomerId();
      let param = {
        customerId: customerId,
        openId: userInfo.openId,
      };
      let res = await getUserInfo(param);
      if (res.code == "10000") {
        this.wxInfo = res.data;
      }
    },
  },

  async created() {
    await wxAuth.auth();
    let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
    headers.customerId = wxAuth.getDecodeCustomerId();
    let customerIdParam = encodeURIComponent(noDecodeCustomerId);
    window.history.replaceState(
      {},
      "",
      `./#/user?customerId=${customerIdParam}`
    );
    this.userInfo = wxAuth.getUserInfo();
    await this.getUserInfo();
    this.getCodeStatus();
    this.getOrderNum();
    this.getUserBills();
  },
};
</script>

<style lang='scss' scoped>
::v-deep .van-tab--active {
  font-weight: bold;
}
::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}
::v-deep .tab_title {
  font-size: 0.37rem ;
  font-family: PingFang SC;
  padding: 0 0.2rem;
  border: 0;
}
.bill_tab {
  height: 1.33rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user_info {
  padding-left: 0.32rem;
}
.user_name {
  font-size: 0.48rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.user_phone {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
main {
  // height: calc(100% - 5.6rem);
  position: relative;
  left: 0;
  // top: -1.22rem;
  margin-top: -1.22rem;
  // margin-bottom: -1.22rem;
  padding: 0 0.4rem;
  z-index: 1;
}
.main {
  // height: calc(100vh - 3.96rem - 2.13rem - 0.266667rem - 1.306667rem - 0.266667rem - 1.33rem);
  height: calc(100% - 2.13rem - 1.3rem);;
  overflow-y: scroll;
}
.main_header {
  width: 9.2rem;
  height: 2.13rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #ffffff;
  box-shadow: 0rem 0.013333rem 0.026667rem 0rem #ebebeb;
  border-radius: 0.266667rem;
  background: #fff;
}
.main_header_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.header {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  height: 5.6rem;
  background-image: url("../static/image/index_bg.png");
  background-size: 100% 100%;
}
.title {
  height: 0.47rem;
  padding: 0.36rem 0;
  padding-left: 0.41rem;
  font-size: 0.42rem;
  font-family: PingFang SC;
  font-weight: bold;
  text-align: start;
  color: #ffffff;

}
.user {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.64rem 0;
  padding-left: 0.41rem;
}
.user_left {
  display: flex;
  align-items: center;
}
.user_right {
  padding: 0.053333rem;
  padding-right: 0;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 34px 0px 0px 34px;
}
.user_right_text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.133333rem;
  height: 0.8rem;
  background: #ffffff;
  border-radius: 0.386667rem 0rem 0rem 0.386667rem;
  font-size: 0.373333rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #495ce1;
}
.user_head {
  width: 1.39rem;
  height: 1.39rem;
  border-radius: 50%;
}
.footer {
  width: 100%;
  height: 1.31rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.num {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #495ce1;
  line-height: 0.306667rem;
  padding-bottom: 0.24rem;
}
.balance {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #495ce1;
  line-height: 0.306667rem;
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1.813333rem;
  font-size: 0.346667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #b3b3b3;
}
.empty img {
  width: 5.333333rem;
  height: 3.333333rem;
}
.wrap {
  width: 9.2rem;
  background: #ffffff;
  box-shadow: 0rem 0.013333rem 0.026667rem 0rem #ebebeb;
  border-radius: 0.266667rem;
  box-sizing: border-box;
  margin-bottom: 0.266667rem;
}
.wrap_header {
  display: flex;
  justify-content: space-between;
  padding: 0.466667rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;
}
.bills {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.status {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff553e;
}
.wrap_box {
  padding: 0.32rem 0.32rem 0 0.32rem;
}
.wrap_box_item {
  padding-bottom: 0.32rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.des {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  padding-right: 2px;
}
.more {
  height: 1rem;
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: center;
  color: #666666;
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;
}
.footer {
  width: 100%;
  height: 1.306667rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.footer_left {
  display: flex;
  align-items: center;
  padding-left: 0.4rem;
}
.footer_user_head {
  width: 0.933333rem;
  height: 0.933333rem;
  border-radius: 50%;
}
.footer_des {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  padding-left: 0.266667rem;
}
.footer_rifht {
  width: 2.666667rem;
  height: 0.96rem;
  background: #495ce1;
  border-radius: 0.48rem;
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.4rem;
}
.qrCode_box {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 888;
}
.qrCode {
  width: 6.666667rem;
  height: 7.36rem;
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
  position: absolute;
  top: 40%;
  left: 50%;
  z-index: 1000;
  padding: 0.533333rem 1.333333rem;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
}
.qrCode img {
  width: 4rem;
  height: 4rem;
  margin: 0 auto;
}
.qrCode_title {
  font-size: 0.48rem;
  text-align: center;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.qr_text {
  font-size: 0.373333rem;
  text-align: center;
  font-family: PingFang SC;
  font-weight: bold;
  color: #888888;
  padding-bottom: 0.4rem;
}
.btn {
  width: 3.733333rem;
  height: 0.96rem;
  line-height: 0.96rem;
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  background: #495ce1;
  margin: 0 auto;
  border-radius: 0.48rem 0.466667rem 0.493333rem 0.48rem;
}
.good_detial {
  /* width: 4.533333rem; */
  white-space: nowrap;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  text-overflow: ellipsis;
}
#app {
  background: #f5f5f5;
  overflow: hidden;
}
</style>
